import { Modal, Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { tokens } from "../../theme";

const DetailRow = ({ label, value, colors }) => (
  <Box display="flex" justifyContent="space-between" borderBottom={`1px solid ${colors.primary[300]}`} pb={1}>
    <Typography variant="h6" fontWeight="bold" color={colors.grey[300]}>
      {label}:
    </Typography>
    <Typography variant="h6" color={colors.grey[100]} sx={{ wordBreak: "break-word", textAlign: "right", maxWidth: "70%" }}>
      {value || "N/A"}
    </Typography>
  </Box>
);

export function ViewDocumentModal({ modal, setModal, title }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const handleClose = () => {
    setModal((prevValue) => ({ ...prevValue, open: false }));
  };

  return (
    <Modal open={modal?.open} onClose={handleClose}>
      <Box
        sx={{
          width: modal?.ninDetails ? "55%" : "30%",
          maxHeight: "90%",
          overflowY: "auto",
          backgroundColor: colors.primary[400],
          p: 4,
          position: "relative",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "5px",
          outline: "none",
        }}
      >
        {modal?.ninDetails ? (
          <Box>
            <Typography variant="h3" mb={3} fontWeight="bold" color={colors.grey[100]}>
              NIN Verification Details
            </Typography>
            <Box display="flex" gap="30px" flexDirection={{ xs: "column", md: "row" }}>
              {/* Images Column */}
              <Box flex={1} display="flex" flexDirection="column" alignItems="flex-start" gap="20px">
                {modal.ninDetails.imageUrl && (
                  <Box width="100%">
                    <Typography variant="h6" mb={1} color={colors.grey[300]} fontWeight="bold">
                      Photo
                    </Typography>
                    <Box display="flex" justifyContent="flex-start">
                      <img
                        src={modal.ninDetails.imageUrl}
                        alt="NIN Photo"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "220px",
                          borderRadius: "8px",
                          border: `1px solid ${colors.grey[700]}`,
                          objectFit: "contain"
                        }}
                      />
                    </Box>
                  </Box>
                )}
                {modal.ninDetails.signature && (
                  <Box width="100%">
                    <Typography variant="h6" mb={1} color={colors.grey[300]} fontWeight="bold">
                      Signature
                    </Typography>
                    <Box display="flex" justifyContent="flex-start">
                      <img
                        src={modal.ninDetails.signature}
                        alt="NIN Signature"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "75px",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          padding: "5px",
                          border: `1px solid ${colors.grey[700]}`,
                          objectFit: "contain"
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>

              {/* Text Info Column */}
              <Box flex={1.5} display="flex" flexDirection="column" gap="14px">
                <DetailRow label="NIN" value={modal.ninDetails.nin} colors={colors} />
                <DetailRow label="First Name" value={modal.ninDetails.firstname} colors={colors} />
                <DetailRow label="Surname" value={modal.ninDetails.surname} colors={colors} />
                <DetailRow label="Middle Name" value={modal.ninDetails.middlename} colors={colors} />
                <DetailRow label="Birth Date" value={modal.ninDetails.birthdate} colors={colors} />
                <DetailRow label="Gender" value={modal.ninDetails.gender?.toUpperCase()} colors={colors} />
                <DetailRow label="Phone" value={modal.ninDetails.telephoneno} colors={colors} />
                <DetailRow label="Residence Address" value={modal.ninDetails.residenceAddress} colors={colors} />
              </Box>
            </Box>
          </Box>
        ) : (
          <>
            {title && (
              <Typography variant="h3" my={3} textAlign="center">
                {title}
              </Typography>
            )}
            {modal?.imgUrl ? (
              <img src={modal?.imgUrl} height="100%" width="100%" />
            ) : (
              <Typography variant="h5" textAlign="center" my={3} mt={30}>
                No document found
              </Typography>
            )}
          </>
        )}
      </Box>
    </Modal>
  );
}
